import { StorageProvider } from 'app/shared';

export class AuthHttpConfig {

  constructor(
    private tokenName: string,
    private storageProvider: StorageProvider
  ) { }

  public getToken(): string {
    return this.storageProvider.get(this.tokenName);
  }

  public setToken(token: string): void {
    this.storageProvider.set(this.tokenName, token);
  }

  public removeToken(): void {
    this.storageProvider.remove(this.tokenName);
  }
}



// WEBPACK FOOTER //
// /dist/src/app/security/authorization/auth-http-config.ts